"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const lastTimestampFromPricesMap = history => history.size === 0 ? null : Math.max(...history.keys());

var _default = lastTimestampFromPricesMap;
exports.default = _default;